@if (!smallMode()) {
<button type="button" class="primary-button inline-flex flex-row items-center gap-x-2" #selectCreativeDrawerButton
    command="show-modal" commandfor="selectCreativeDrawer">
    Select Creatives
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
        <path d="M5 12h14" />
        <path d="M12 5v14" />
    </svg>
</button>
} @else {
<button type="button" class="btn-shout btn-shout-xs btn-shout-primary inline-flex flex-row items-center gap-x-2" #selectCreativeDrawerButton
    command="show-modal" commandfor="selectCreativeDrawer">
    Change Creative
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
        <path
            d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
        <path d="m15 5 4 4" />
    </svg>
</button>
}



<el-dialog>
    <dialog #selectCreativeDrawerDialog id="selectCreativeDrawer" aria-labelledby="selectCreativeDrawer-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block h-full w-[50vw] min-w-[50vw] transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl ">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-zinc-200 dark:divide-zinc-800">

                        <!-- header -->
                        <div class="px-2 py-4 drawer-header-primary">
                            <div class="flex space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2">
                                    <p class="text-md font-semibold text-primary">
                                        Select Creative
                                    </p>
                                    <p class="text-sm text-secondary">
                                        Select the video that you'd like to use for your Spark Ad.
                                    </p>
                                </div>

                                <div class="h-full flex flex-col justify-between items-end">

                                    <button type="button" (click)="closeDrawer()"
                                        class="fab-button-secondary text-secondary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative h-full flex-1 flex flex-col items-center justify-center w-full overflow-hidden drawer-body-primary divide-y divide-zinc-200 dark:divide-zinc-800">

                            <!-- Top Filters -->
                            <div
                                class="shrink-0 w-full flex flex-row items-center justify-between px-2 py-2 border-b border-zinc-200 dark:border-zinc-800">

                                <div class="grid grid-cols-1 w-1/2">
                                    <input id="email" type="email" name="email" placeholder="Keyword Search..."
                                        class="col-start-1 row-start-1 block w-full py-1.5 pr-3 pl-10 input-primary-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-secondary sm:size-4">
                                        <path d="m21 21-4.34-4.34" />
                                        <circle cx="11" cy="11" r="8" />
                                    </svg>
                                </div>

                            </div>
                            <!-- Top Filters - END -->

                            <!-- Main Content List -->
                            <div class="flex-1 flex flex-col w-full p-4">

                                @if (ttoVideos().length > 0) {
                                <ul role="list" class="grid grid-cols-2 gap-4 sm:grid-cols-3 w-full">
                                    @for (video of ttoVideos(); track video.video_info.video_id) {
                                    <li class="relative">
                                        @let videoId = video.video_info.video_id;
                                        <div (mouseenter)="setHoveredVideo(videoId)"
                                            (mouseleave)="setHoveredVideo(undefined)"
                                            [class]="'group relative aspect-10/7 overflow-hidden rounded-lg focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary dark:focus-within:outline-primary ' + (isSelectedCreative(video) ? 'bg-primary/10 ring-2 ring-primary dark:bg-primary/10 dark:ring-primary' : 'bg-gray-100 dark:bg-gray-800')">
                                            <video #videoEl [src]="video.video_info.embed_url" preload="metadata"
                                                playsinline muted (play)="onVideoPlay(videoId)"
                                                (pause)="onVideoPause(videoId)" (ended)="onVideoPause(videoId)"
                                                class="pointer-events-none h-full w-full rounded-lg object-contain outline -outline-offset-1 outline-black/5 group-hover:opacity-75 dark:outline-white/10">
                                            </video>
                                            <div class="absolute right-2 top-2 z-30">
                                                <button type="button"
                                                    (click)="$event.stopPropagation(); toggleCreativeSelection(video)"
                                                    [attr.aria-pressed]="isSelectedCreative(video)"
                                                    [attr.aria-label]="isSelectedCreative(video) ? 'Deselect creative' : 'Select creative'"
                                                    [class]="'inline-flex size-6 items-center justify-center rounded border transition ' + (isSelectedCreative(video) ? 'border-primary bg-primary text-white dark:border-primary dark:bg-primary' : 'border-white/80 bg-black/40 text-transparent hover:border-white hover:text-white')">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                        fill="currentColor" class="size-4" aria-hidden="true">
                                                        <path fill-rule="evenodd"
                                                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.03-2.28a.75.75 0 1 0-1.06-1.06l-4.22 4.22-2.22-2.22a.75.75 0 0 0-1.06 1.06l2.75 2.75a.75.75 0 0 0 1.06 0l4.75-4.75Z"
                                                            clip-rule="evenodd" />
                                                    </svg>
                                                </button>
                                            </div>
                                            @if (video.video_info.embed_url && (!isVideoPlaying(videoId) ||
                                            hoveredVideoId() === videoId)) {
                                            <button type="button"
                                                (click)="$event.stopPropagation(); toggleVideoPlayback(videoEl)"
                                                class="absolute inset-0 z-20 flex items-center justify-center focus:outline-hidden">
                                                <span
                                                    class="inline-flex size-11 items-center justify-center rounded-full bg-black/65 text-white ring-1 ring-white/20 transition hover:bg-black/75">
                                                    @if (isVideoPlaying(videoId)) {
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                        fill="currentColor" class="size-5" aria-hidden="true">
                                                        <path
                                                            d="M8.25 6A2.25 2.25 0 0 1 10.5 8.25v7.5A2.25 2.25 0 0 1 8.25 18h-.75A2.25 2.25 0 0 1 5.25 15.75v-7.5A2.25 2.25 0 0 1 7.5 6h.75Zm8.25 0a2.25 2.25 0 0 1 2.25 2.25v7.5A2.25 2.25 0 0 1 16.5 18h-.75a2.25 2.25 0 0 1-2.25-2.25v-7.5A2.25 2.25 0 0 1 15.75 6h.75Z" />
                                                    </svg>
                                                    } @else {
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                                        fill="currentColor" class="ml-0.5 size-5" aria-hidden="true">
                                                        <path
                                                            d="M8.28 5.31A1 1 0 0 0 6.75 6.16v11.68a1 1 0 0 0 1.53.85l9.12-5.84a1 1 0 0 0 0-1.68L8.28 5.31Z" />
                                                    </svg>
                                                    }
                                                </span>
                                                <span class="sr-only">{{ isVideoPlaying(videoId) ? 'Pause video' : 'Play
                                                    video' }}</span>
                                            </button>
                                            }
                                        </div>
                                        <p
                                            class="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900 dark:text-white">
                                            {{ video.creator_info.display_name }}</p>
                                        @if (isSelectedCreative(video)) {
                                        <p class="text-xs font-medium text-accent">Selected</p>
                                        }
                                    </li>
                                    }
                                </ul>
                                } @else {
                                <div
                                    class="flex h-full w-full items-center justify-center rounded-lg border border-dashed border-gray-300 p-6 dark:border-gray-700">
                                    <p class="text-sm text-gray-500 dark:text-gray-400">No videos available yet.</p>
                                </div>
                                }


                            </div>
                            <!-- Main Content List - END -->

                            <!-- Footer -->
                            <div
                                class="shrink-0 w-full flex flex-row items-center justify-end px-2 py-2 border-t border-zinc-200 dark:border-zinc-800">
                                <button (click)="confirmSelection()" type="button" [disabled]="!hasSelectedCreative()"
                                    class="primary-button disabled:cursor-not-allowed disabled:opacity-50">
                                    <span>Select</span>
                                </button>
                            </div>
                            <!-- Footer - END -->

                        </div>
                        <!-- main content - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>